"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _entitiesReducer = _interopRequireDefault(require("./entitiesReducer"));

var _stagedReducer = _interopRequireDefault(require("./stagedReducer"));

var _default = (0, _redux.combineReducers)({
  entities: _entitiesReducer.default,
  staged: _stagedReducer.default
});

exports.default = _default;
module.exports = exports.default;